__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-mc-all/').replace(/[/]{3,}/g, "/");